import { Link, useParams , useLocation} from "react-router-dom";
import FGInput from "../../../components/dumb/FGInput";
import usePageTitle from "../../../hooks/use-page-title";
import { HiArrowLeft, HiX } from "react-icons/hi";
import { ROUTES } from "../../../routes";
import Notifier from "../../../modules/notifier/notifier";
import { MdSave } from "react-icons/md";
import { useContext, useEffect, useState } from "react";
import Multilingual from "../../../modules/multilingual/multilingual";
import { usePortalSettingSet } from "../../../context/portal-context";
import Debouncer from "../../../modules/debouncer/debouncer";
import FGTextarea from "../../../components/dumb/FGTextarea";
import ApiGroup from "../../../modules/api/group";
import AppUserContext from "../../../context/app-user-context";
import PagePortalNotFound from "../PagePortalNotFound/PagePortalNotFound";
import FooterBoxAction from "../../../components/common/FooterBoxAction";
import { BsBoxArrowInDown } from "react-icons/bs";

export default function PageGroupEdit() {
  const title = "Edit Group";
  usePageTitle(title);
  usePortalSettingSet("label_header", title);
  const location = useLocation();
  const { programmeId, cohortId, _id } = useParams();
  const user = useContext(AppUserContext);
  const isValidProgrammeId = user.programmeIds.includes(programmeId);
  const [contentChanged, setContentChanged] = useState(false);
  const [sending, setSending] = useState(false);
  const [found, setFound] = useState(false);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    name: "",
    description: ""
  });

  useEffect(() => {
    if (!isValidProgrammeId) {
      return;
    }
    ApiGroup.get(_id).then(res => {
      if (res.status) {
        setFound(true);
        setFormData(res.data);
      } else {
        setFound(false);
        Notifier.error(res.message);
      }

      setLoading(false);
    })
  }, []);

  const handleOnChange = (e) => {
    setContentChanged(true);
    setFormData(d => ({
      ...d,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    Debouncer.execute("UPDATE_DATA", async () => {
      setSending(true);
      const res = await ApiGroup.update(_id, {
        name: formData.name,
        description: formData.description
      });

      if (res.status) {
        setContentChanged(false);
        Notifier.success(res.message);
      } else {
        Notifier.error(res.message);
      }

      setSending(false);
    });
  };

  if (!isValidProgrammeId) {
    return <PagePortalNotFound />
  }
  return <main className="form-generic content-generic">

    <h1 className="fs-title hide-mobile-down">Edit Group</h1>

    {/* <div className="cg__actions hide-mobile-down">
      <Link to={`${ROUTES.PORTAL_GROUPS}/${programmeId}/${cohortId}`} className="btn btn-primary" state={location.state} onClick={(e) => {
        if (contentChanged && !window.confirm(Multilingual.get("CONFIRM_ACTION_CANT_BE_UNDONE"))) {
          e.preventDefault();
        }
      }}>
        <HiArrowLeft/>{" "}Back
      </Link>
    </div> */}

    {loading && <p className="alert alert-info">
      Loading data...
    </p>}

    {!loading && !found && <p className="alert alert-info">
      Group not found.
    </p>}

    {!loading && found && <form onSubmit={handleSubmit}>

      <FGInput name="name" id="name" type="text" label="Name" required autoFocus
        value={formData.name}
        onChange={handleOnChange}
      />

      <FGTextarea name="description" id="description" label="Description"
        value={formData.description}
        onChange={handleOnChange}
      />

      <div>
        <button type="submit" className="btn btn-secondary" disabled={sending}>
          <BsBoxArrowInDown className="icon-pos-upper" />{" "}Save
        </button>
        {" "}
        <Link to={`${ROUTES.PORTAL_GROUPS}/${programmeId}/${cohortId}`} className="btn btn-primary" state={location.state} onClick={(e) => {
          if (contentChanged && !window.confirm(Multilingual.get("CONFIRM_ACTION_CANT_BE_UNDONE"))) {
            e.preventDefault();
          }
        }}>
          <HiX/>{" "}Cancel
        </Link>
      </div>

    </form>}


      <FooterBoxAction backUrl={`${ROUTES.PORTAL_GROUPS}/${programmeId}/${cohortId}`} backUrlState={location.state} onBackUrlClick={(e) => {
        if (contentChanged && !window.confirm(Multilingual.get("CONFIRM_ACTION_CANT_BE_UNDONE"))) {
          e.preventDefault();
        }
      }}/>
  </main>;
}
